<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <div class="page">
            <div class="vertical-flow">
                <div class="form-columns-fit mb-5">
                    <div class="columns is-flex-wrap">
                        <div class="column px-0 is-12 is-flex is-flex-hbetween">
                            <div class="column px-0 is-6 is-flex">
                                <div class="column">
                                    <v-money
                                        ref="cotaInput"
                                        v-model="contaFlexOnlyWithParams.cota"
                                        title="cota"
                                        tooltipLabel="tooltip-flex-cota"
                                        placeholder="placeholder-preencha"
                                        suffix="%"
                                        :max="100"
                                        :min="0"
                                        :tooltipMultilined="true"
                                        tooltipPosition="is-top"
                                        tooltipSize="is-small"
                                        :disabled="isSaving"
                                        msg="msg-campo-obrigatorio"
                                        :invalid="isNull(contaFlexOnlyWithParams.cota)"
                                        required
                                    />
                                </div>
                                <div class="column">
                                    <v-money
                                        ref="valorMinimoInput"
                                        required
                                        title="valor-minimo"
                                        tooltipLabel="tooltip-flex-valor-minimo"
                                        msg="msg-campo-obrigatorio"
                                        v-model="
                                            contaFlexOnlyWithParams.valorMinimo
                                        "
                                        :invalid="
                                            isNull(
                                                contaFlexOnlyWithParams.valorMinimo
                                            )
                                        "
                                        :max="9999999"
                                        :min="-9999999"
                                        :disabled="isSaving"
                                    />
                                </div>
                            </div>
                            <div class="is-6 is-flex is-flex-hleft">
                                <button
                                    v-if="!integracao && permissao.create"
                                    class="save-btn h-max-content size mr-5c"
                                    type="button"
                                    margin="button"
                                    @click="updateContaFlexParametrizacao"
                                >
                                    {{ $t("salvar") }}
                                </button>
                            </div>
                        </div>
                        <div class="column px-0 is-12 is-flex">
                            <div class="column is-3">
                                <vss-select
                                    ref="regraTrabalhoSelected"
                                    tooltipLabel="tooltip-flex-regra-trabalho"
                                    required
                                    title="regra-trabalho"
                                    v-model="regraTrabalhoSelected"
                                    :invalid="isNull(regraTrabalhoSelected)"
                                    :options="regraTrabalhoList"
                                    :disabled="isSaving"
                                    mlLabels
                                    placeholder="selecione-uma-opcao"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    v-show="regraTrabalhoSelected.id === 0"
                                    ref="operacaoSelected"
                                    required
                                    title="operacao"
                                    tooltipLabel="tooltip-flex-operacao"
                                    v-model="operacaoSelected"
                                    :invalid="isNull(operacaoSelected)"
                                    :options="operacaoList"
                                    :disabled="isSaving"
                                    mlLabels
                                    placeholder="selecione-uma-opcao"
                                />
                            </div>
                        </div>
                        <div class="column px-0 is-12 is-flex">
                            <div class="column is-3">
                                <vss-select
                                    :title="
                                        regraTrabalhoSelected.id === 2
                                            ? 'operacao-fiscal'
                                            : 'tipo-pedido'
                                    "
                                    placeholder="selecione"
                                    :options="tipoPedidoList"
                                    v-model="tipoPedidoSelected"
                                    :loading="tipoPedidoLoading"
                                    @search="carregarTipoPedido"
                                    required
                                    multiple
                                    searchable
                                    clearable
                                    :closeOnSelect="false"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    title="origem-pedido"
                                    placeholder="selecione"
                                    :options="origemPedidoList"
                                    :loading="origemPedidoLoading"
                                    v-model="origensPedidoSelected"
                                    required
                                    multiple
                                    clearable
                                    :closeOnSelect="false"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    v-show="regraTrabalhoSelected.id != 3"
                                    title="situacao-liberacao-saldo"
                                    placeholder="selecione"
                                    :options="situacoesLiberacaoList"
                                    :loading="situacaoLoading"
                                    v-model="situacoesLiberacaoSelected"
                                    required
                                    multiple
                                    clearable
                                    :closeOnSelect="false"
                                />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    v-show="regraTrabalhoSelected.id != 3"
                                    title="situacao-estorno-saldo"
                                    placeholder="selecione"
                                    :options="situacoesEstornoList"
                                    :loading="situacaoLoading"
                                    v-model="situacoesEstornoSelected"
                                    required
                                    multiple
                                    clearable
                                    :closeOnSelect="false"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="registry-wrapper pb-10">
                    <h3 class="has-text-primary custom-subtitle mb-2">
                        {{ $t("titulo-parametrizacao-conta-corrente") }}
                    </h3>
                    <div
                        v-for="(parametro, index) in parametrosMap"
                        :key="index"
                        class="columns mt-2"
                    >
                        <div class="is-flex mx-3">
                            <b-switch
                                v-model="parametro.ativo"
                                size="is-medium"
                            >
                            </b-switch>
                            <label class="label">
                                {{ $t(parametro.descricao) }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FlexService from "@/services/vendas/financeiro/FlexService.js";
import ContainerLoader from "@/components/content/loader/ContainerLoader.vue";
import ChartDebitoCredito from "@/components/vendas/financeiro/flex/ChartDebitoCredito.vue";
import TipoPedidoService from "@/services/vendas/TipoPedidoService.js";
import PedidoService from "@/services/PedidoService";

export default {
    name: "Configuracoes",

    components: {
        ContainerLoader,
        ChartDebitoCredito,
    },

    props: {
        contaFlex: {
            type: Object,
            default: (_) => null,
        },
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("VEN_FLEX"),
            service: new FlexService(this.$http, this.$router),
            tipoPedidoService: new TipoPedidoService(this.$http, this.$router),
            pedidoService: new PedidoService(this.$http, this.$router),
            permissao: {},
            showModal: false,
            isSaving: false,
            accessDenied: false,
            tipoPedidoList: [],
            tipoPedidoSelected: [],
            tipoPedidoToDelete: [],
            tipoPedidoLoading: false,
            situacaoLoading: false,
            origemPedidoList: [],
            origensPedidoSelected: [],
            origensPedidoToDelete: [],
            origemPedidoLoading: false,
            regraTrabalhoList: [
                {
                    id: 0,
                    label: "pedido-upper",
                },
                {
                    id: 1,
                    label: "retorno-pedido",
                },
                {   
                    id: 2,
                    label: "nota-fiscal",
                },
                {   
                    id: 3,
                    label: "lancamento-erp",
                },
            ],
            regraTrabalhoSelected: null,
            operacaoList: [
                {
                    id: 0,
                    label: "debita-automatico",
                },
                {
                    id: 1,
                    label: "credita-automatico",
                },
                {
                    id: 2,
                    label: "debita-credita-automatico",
                },
                {
                    id: 3,
                    label: "debita-credita-manualmente",
                },
            ],
            operacaoSelected: null,
            dicsStatus: {
                N: "nao-enviado",
                E: "processando",
                S: "transmitido",
                C: "cancelado",
                ED: "em-edicao",
                AP: "aguardando-aprovacao",
                A: "aprovado",
                F: "faturado",
                D: "deletado",
                EI: "problema-integracao-erp",
            },
            situacoesBaseList: [],
            situacoesLiberacaoList: [],
            situacoesLiberacaoSelected: [],
            situacoesLiberacaoToDelete: [],
            situacoesEstornoList: [],
            situacoesEstornoSelected: [],
            situacoesEstornoToDelete: [],
            contaFlexOnlyWithParams: {},
            parametrosMap: {
                porcProdAdd: {
                    descricao: "porc-prod-add",
                    ativo: false,
                },
                porcProdDesc: {
                    descricao: "porc-prod-desc",
                    ativo: false,
                },
                valorProdMaior: {
                    descricao: "valor-prod-maior",
                    ativo: false,
                },
                valorProdMenor: {
                    descricao: "valor-prod-menor",
                    ativo: false,
                },
                validaFlexNoFinal: {
                    descricao: "valida-flex-no-final",
                    ativo: false,
                },
                flexBonifValorTabPreco: {
                    descricao: "flex-bonif-valor-tab-preco",
                    ativo: false,
                },
                porcPedidoDesc: {
                    descricao: "porc-pedido-desc",
                    ativo: false,
                },
            },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "flex"
        );

        this.contaFlexToSelects();
        this.loadStatusPedido();
        this.loadOrigensPedido();

        const {
            saldoTotalGerado,
            saldoTotalBloqueado,
            saldoTotalLiberado,
            datahorainc,
            datahoraalt,
            idEmpresa,
            idUsuario,
            idVenFlexErp,
            nomeEmpresa,
            nomeUsuario,
            replicapda,
            situacao,
            origensPedido,
            statusEstornaSaldo,
            ...contaFlexOnlyWithParams
        } = this.contaFlex;

        for (const key in this.parametrosMap) {
            this.parametrosMap[key].ativo = Boolean(
                contaFlexOnlyWithParams[key]
            );
        }

        this.contaFlexOnlyWithParams = {
            ...contaFlexOnlyWithParams,
        };
    },
    watch: {
        situacoesLiberacaoSelected(newValue) {
            this.situacoesEstornoList = this.removeSelectedFromList(newValue);
        },
        situacoesEstornoSelected(newValue) {
            this.situacoesLiberacaoList = this.removeSelectedFromList(newValue);
        },
        regraTrabalhoSelected(newValue) {
            this.filterSituacaoListByRegraTrabalho(newValue.id);

            if (newValue.id != this.contaFlex.regraTrabalho) {
                this.situacoesEstornoSelected = [];
                this.situacoesLiberacaoSelected = [];
            } else {
                this.situacoesEstornoSelected =
                    this.mapSelectedSituacaoToSelect(
                        this.contaFlex.statusEstornaSaldo
                    );

                this.situacoesEstornoToDelete = this.situacoesEstornoSelected;

                this.situacoesLiberacaoSelected =
                    this.mapSelectedSituacaoToSelect(
                        this.contaFlex.statusLiberacao
                    );

                this.situacoesLiberacaoToDelete =
                    this.situacoesLiberacaoSelected;
            }
        },
    },
    methods: {
        filterSituacaoListByRegraTrabalho(idRegraTrabalho) {
            if (idRegraTrabalho == 2) {
                const situacaoRegistroEnviadoOnly =
                    this.situacoesBaseList.filter(({ id }) => Number(id) < 0);

                this.situacoesEstornoList = situacaoRegistroEnviadoOnly;
                this.situacoesLiberacaoList = situacaoRegistroEnviadoOnly;
            } else {
                const situacaoStatusWfOnly = this.situacoesBaseList.filter(
                    ({ id }) => Number(id) > 0
                );

                this.situacoesEstornoList = situacaoStatusWfOnly;
                this.situacoesLiberacaoList = situacaoStatusWfOnly;
            }
        },
        removeSelectedFromList(newValue) {
            if (this.regraTrabalhoSelected.id == 0) {
                const situacaoRegistroEnviadoOnly =
                    this.situacoesBaseList.filter(({ id }) => Number(id) < 0);

                return situacaoRegistroEnviadoOnly.filter(
                    ({ id: baseId }) =>
                        !newValue.some(({ id }) => id === baseId)
                );
            }

            const situacaoStatusWfOnly = this.situacoesBaseList.filter(
                ({ id }) => Number(id) > 0
            );

            return situacaoStatusWfOnly.filter(
                ({ id: baseId }) => !newValue.some(({ id }) => id === baseId)
            );
        },
        contaFlexToSelects() {
            this.regraTrabalhoSelected = this.regraTrabalhoList.find(
                ({ id }) => id === this.contaFlex.regraTrabalho
            );

            this.operacaoSelected = this.operacaoList.find(
                ({ id }) => id === this.contaFlex.operacao
            );
        },
        mapSelectedOrigensToSelects() {
            this.origensPedidoSelected = this.origemPedidoList.filter(
                ({ label }) =>
                    this.contaFlex.origensPedido.some(
                        ({ origemPedido }) =>
                            origemPedido.toUpperCase() === label
                    )
            );

            this.origensPedidoToDelete = this.origensPedidoSelected;            
        },
        mapSelectedTipoPedidoToSelects() {
            this.tipoPedidoSelected = this.tipoPedidoList.filter(({ id }) =>
                this.contaFlex.assFlexTipoPedido.some(
                    ({ idTipoPedido }) => id === idTipoPedido
                )
            );

            this.tipoPedidoToDelete = this.tipoPedidoSelected;
        },
        mapSelectedSituacaoToSelect(situacoesList) {
            return this.situacoesBaseList.filter(({ status }) =>
                situacoesList.some(
                    ({ status: statusString, idStatusWf }) =>
                        status === statusString || Number(status) === idStatusWf
                )
            );
        },
        loadStatusPedido() {
            this.situacaoLoading = true;

            this.pedidoService
                .getStatusPedidoCombo()
                .then((r) => {
                    this.situacoesBaseList = Object.entries(r.content).map(
                        ([key, val]) => this.formatStatusSelect(key, val)
                    );

                    this.situacoesEstornoSelected =
                        this.mapSelectedSituacaoToSelect(
                            this.contaFlex.statusEstornaSaldo
                        );

                    this.situacoesEstornoToDelete =
                        this.situacoesEstornoSelected;

                    this.situacoesLiberacaoSelected =
                        this.mapSelectedSituacaoToSelect(
                            this.contaFlex.statusLiberacao
                        );

                    this.situacoesLiberacaoToDelete =
                        this.situacoesLiberacaoSelected;
                })
                .catch((e) => {
                    console.error("Erro ao carregar as origens.", e);
                })
                .finally((_) => {
                    this.filterSituacaoListByRegraTrabalho(
                        this.contaFlex.regraTrabalho
                    );
                    
                    this.situacoesEstornoList = this.removeSelectedFromList(
                        this.situacoesLiberacaoSelected
                    );

                    this.situacoesLiberacaoList = this.removeSelectedFromList(
                        this.situacoesEstornoSelected
                    );

                    this.situacaoLoading = false;
                });
        },
        loadOrigensPedido() {
            this.origemPedidoLoading = true;

            this.pedidoService
                .getOrigensPedidoCombo()
                .then((r) => {
                    this.origemPedidoList = Object.entries(r.content).map(
                        ([key, val]) => {
                            return {
                                id: key,
                                label: val.toUpperCase(),
                            };
                        }
                    );
                })
                .catch((e) => {
                    console.error("Erro ao carregar as origens.", e);
                })
                .finally((_) => {
                    this.origemPedidoLoading = false;
                    this.mapSelectedOrigensToSelects();
                });
        },
        formatStatusSelect(key, val) {
            const valorMaiusculo = val.toUpperCase();

            const formettedOption = {
                id: key,
                status: key > 0 ? key : val,
                label:
                    valorMaiusculo in this.dicsStatus
                        ? this.$t(this.dicsStatus[valorMaiusculo]).toUpperCase()
                        : valorMaiusculo,
            };

            return formettedOption;
        },
        mapContaFlex(contaFlex) {
            const contaFlexMapped = contaFlex;

            for (const key in this.parametrosMap) {
                contaFlexMapped[key] = Number(this.parametrosMap[key].ativo);
            }

            contaFlexMapped.operacao = this.operacaoSelected.id;

            contaFlexMapped.regraTrabalho = this.regraTrabalhoSelected.id;

            contaFlexMapped.origensPedido = this.origensPedidoSelected
                .map(({ label: origemPedido }) => ({ origemPedido }))
                .filter(
                    ({ origemPedido }) =>
                        !this.contaFlex.origensPedido.some(
                            ({ origemPedido: origemPedidoSelected }) =>
                                origemPedidoSelected === origemPedido
                        )
                );

            contaFlexMapped.origensPedidoToDelete = this.origensPedidoToDelete
                .filter(
                    ({ id }) =>
                        !this.origensPedidoSelected.some(
                            ({ id: idSelected }) => idSelected === id
                        )
                )
                .map(({ label: origemPedido }) => origemPedido);

            contaFlexMapped.statusLiberacao = this.situacoesLiberacaoSelected
                .map(({ status }) => {
                    if (this.regraTrabalhoSelected.id == 0) {
                        return {
                            status,
                        };
                    }

                    return {
                        idStatusWf: status,
                    };
                })
                .filter(
                    ({ status, idStatusWf }) =>
                        !this.contaFlex.statusEstornaSaldo.some(
                            ({
                                status: statusSelected,
                                idStatusWf: idStatusWfSelected,
                            }) =>
                                (status === statusSelected &&
                                    (status || statusSelected)) ||
                                idStatusWfSelected === Number(idStatusWf)
                        )
                );

            contaFlexMapped.statusLiberacaoToDelete =
                this.situacoesLiberacaoToDelete
                    .filter(
                        ({ id }) =>
                            !this.situacoesLiberacaoSelected.some(
                                ({ id: idSelected }) => idSelected === id
                            )
                    )
                    .map(({ id }) => id);

            contaFlexMapped.statusEstornaSaldo = this.situacoesEstornoSelected
                .map(({ status }) => {
                    if (this.regraTrabalhoSelected.id == 0) {
                        return {
                            status,
                        };
                    }

                    return {
                        idStatusWf: status,
                    };
                })
                .filter(
                    ({ status, idStatusWf }) =>
                        !this.contaFlex.statusEstornaSaldo.some(
                            ({
                                status: statusSelected,
                                idStatusWf: idStatusWfSelected,
                            }) =>
                                (status === statusSelected &&
                                    (status || statusSelected)) ||
                                idStatusWfSelected === Number(idStatusWf)
                        )
                );

            contaFlexMapped.statusEstornaSaldoToDelete =
                this.situacoesEstornoToDelete
                    .filter(
                        ({ id }) =>
                            !this.situacoesEstornoSelected.some(
                                ({ id: idSelected }) => idSelected === id
                            )
                    )
                    .map(({ id }) => id);

            contaFlexMapped.assFlexTipoPedido = this.tipoPedidoSelected
                .map(({ id: idTipoPedido }) => ({ idTipoPedido }))
                .filter(
                    ({ idTipoPedido }) =>
                        !this.contaFlex.assFlexTipoPedido.some(
                            ({ idTipoPedido: idTipoPedidoSelected }) =>
                                idTipoPedidoSelected === idTipoPedido
                        )
                );

            contaFlexMapped.tipoPedidoToDelete = this.tipoPedidoToDelete
                .filter(
                    ({ id }) =>
                        !this.tipoPedidoSelected.some(
                            ({ id: idSelected }) => idSelected === id
                        )
                )
                .map(({ id }) => id);

            return contaFlexMapped;
        },
        updateContaFlexParametrizacao() {
            this.$emit("isContaFlexLoading");

            const contaFlexMapped = this.mapContaFlex(
                this.contaFlexOnlyWithParams
            );

            this.service
                .updateContaFlex(contaFlexMapped)
                .then((_) => {
                    const msg = this.$t("conta-corrente-alterada-sucesso");

                    this.tipoPedidoToDelete = this.tipoPedidoSelected;

                    this.origensPedidoToDelete = this.origensPedidoSelected;

                    this.situacoesEstornoToDelete =
                        this.situacoesEstornoSelected;

                    this.situacoesLiberacaoToDelete =
                        this.situacoesLiberacaoSelected;

                    this.$root.showMessage("success", msg, true, false);
                })
                .catch((error) => {
                    const msg = this.$t("conta-corrente-alterada-erro");

                    this.$root.showMessage("error", msg, true, false);
                })
                .finally((_) => {
                    this.$emit("saved");
                });
        },
        carregarTipoPedido(query = null) {
            this.tipoPedidoLoading = true;
            query = this.isNull(query) ? ".*" : this.removeToSearch(query);

            this.tipoPedidoService
                .findAllCombo(query)
                .then(this.mapTipoPedidoList)
                .then((value) => {
                    if (value != null) {
                        this.tipoPedidoList = value;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.tipoPedidoLoading = false;
                    this.mapSelectedTipoPedidoToSelects();
                });
        },
        mapTipoPedidoList(response) {
            return response.content.map((m) => {
                return {
                    id: m.id,
                    label: m.descricao,
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.pb-10 {
    padding-bottom: 40px;
}

.mr-5c {
    margin-right: 12px;
}

.custom-subtitle {
    font-weight: bold;
    font-size: 18px;
}

.label {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
}

.size {
    width: 100px;
}

.h-max-content {
    height: max-content;
}

.g-2 {
    gap: 8px;
}

.card-content {
    .content {
        font-weight: bold;
        text-align: center;
        font-size: 3vw;
    }
}

.green {
    color: #7cb342;
}

.orange {
    color: #ffb300;
}

#main {
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;

            .filters-bar-form {
                flex-grow: 1;
            }

            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }

            @media screen and (max-width: 850px) {
                flex-direction: column;

                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
